import { map, catchError, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';


import * as AgentsActions from './agents.actions';

@Injectable()
export class AgentsEffects {
    getAllAgents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AgentsActions.GET_ALL_AGENTS),
            map(reports => {
                if (reports) {
                    return Observable.create({});
                }
            }),
            catchError(err => of(AgentsActions.error({ error: err.message })))
        )
    );

    constructor(
        private actions$: Actions
    ) {}
}